import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import { ModelFilterSchema } from '../model-filter-schema.ts'
import {
  CreditProgramMembershipIdSchema,
  PartnerProgramKindSchema,
} from './billing/partner-program-kind.ts'
import {
  OrganizationIdSchema,
  PartnerProgramIdSchema,
} from './unique-id.models.ts'

/**
 * PartnerProgramDomainSelectModel
 */
export const PartnerProgramDomainSelectModelSchema = z.object({
  partnerProgramId: PartnerProgramIdSchema,
  organizationId: OrganizationIdSchema,
  partnerProgramKind: PartnerProgramKindSchema,
  programMembershipId: CreditProgramMembershipIdSchema.optional(),
})

export type PartnerProgramDomainSelectModel = ZodInfer<
  typeof PartnerProgramDomainSelectModelSchema
>

/**
 * PartnerProgramDomainInsertModel
 */
export const PartnerProgramDomainInsertModelSchema =
  PartnerProgramDomainSelectModelSchema.partial({
    partnerProgramId: true,
  })

export type PartnerProgramDomainInsertModel = ZodInfer<
  typeof PartnerProgramDomainInsertModelSchema
>

/**
 * PartnerProgramDomainUpdateModel
 */
export const PartnerProgramDomainUpdateModelSchema =
  PartnerProgramDomainSelectModelSchema.pick({
    programMembershipId: true,
  })

export type PartnerProgramDomainUpdateModel = ZodInfer<
  typeof PartnerProgramDomainUpdateModelSchema
>

/**
 * PartnerProgramDomainSelectModelFilters
 */
export const PartnerProgramDomainSelectModelFiltersSchema = z
  .object({
    partnerProgramId: ModelFilterSchema(PartnerProgramIdSchema),
    organizationId: ModelFilterSchema(OrganizationIdSchema),
    partnerProgramKind: ModelFilterSchema(PartnerProgramKindSchema),
  })
  .partial()

export type PartnerProgramDomainSelectModelFilters = ZodInfer<
  typeof PartnerProgramDomainSelectModelFiltersSchema
>
